var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic / close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 2 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2929 11.7071L4 5.41421L5.41421 4L11.7071 10.2929L18 4L19.4142 5.41421L13.1213 11.7071L19.4142 18L18 19.4142L11.7071 13.1213L5.41421 19.4142L4 18L10.2929 11.7071Z",
    fill: "#CCCCCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.55b991d16b2b60e2ef30c3efa2cb198f.svg";
export { ForwardRef as ReactComponent };